import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Blog from './views/Blog.vue'
import Cayley from './views/Cayley.vue'
import Planar_Graphs_I from './views/Planar_Graphs_I.vue'
import Random_I from './views/Random_I.vue'
//import Job_Market from './views/Job_Market.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    //{
    //  path:'/job-market',
    //  name:'job-market',
    //  component: Job_Market
    //}
    //{
      //path: '/blog',
      //name: 'blog',
      //component: Blog

    //},
    //{
    //  path: '/cayley',
    //  name: 'cayley',
    //  component: Cayley

    //},
    //{
    //  path: '/planar1',
      //name: 'planar1',
      //component: Planar_Graphs_I

    //},
    //{
      //path: '/random1',
      //name: 'random1',
      //component: Random_I

    //}
  ]
})
